import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_PATH } from '../../Constant/constants';
import useAuth from '../../config/useAuth';

const PatientIdList = () => {
  const { patientId } = useParams();
  const { token } = useAuth();
  const [patientData, setPatientData] = useState(null);
  const [prescriptions, setPrescriptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [patientRes, prescriptionRes] = await Promise.all([
          axios.get(`${API_PATH}/patients/${patientId}`, {
            headers: { Authorization: `Bearer ${token}` }
          }),
          axios.get(`${API_PATH}/medicalrecords/patients/${patientId}/records`, {
            headers: { Authorization: `Bearer ${token}` }
          })
        ]);
        setPatientData(patientRes.data);
        setPrescriptions(prescriptionRes.data);
      } catch (error) {
        console.error('Error fetching patient or prescription history:', error);
      }
    };

    if (token && patientId) {
      fetchData();
    }
  }, [patientId, token]);

  return (
    <div className="container py-5">
      <h4 className="mb-4">Patient History</h4>

      {!patientData ? (
        <p>Loading patient data...</p>
      ) : (
        <>
          {/* Patient Details */}
          <div className="card shadow rounded-4 border-0 mx-auto mb-4" style={{ maxWidth: 500 }}>
            <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center"
                  style={{ width: 60, height: 60, fontSize: 28, marginRight: 20 }}>
                  {patientData.firstName?.charAt(0)}{patientData.lastName?.charAt(0)}
                </div>
                <div>
                  <h4 className="card-title mb-0">{patientData.firstName} {patientData.lastName}</h4>
                  <small className="text-muted">{patientData.gender}</small>
                </div>
              </div>
              <ul className="list-group list-group-flush mb-3">
                <li className="list-group-item"><strong>Date of Birth:</strong> {patientData.dateOfBirth}</li>
                <li className="list-group-item"><strong>Registration Date:</strong> {new Date(patientData.registrationDate).toLocaleString()}</li>
                <li className="list-group-item">
                  <strong>Contacts:</strong>{" "}
                  {patientData.contacts?.map(c => `${c.type}: ${c.value}`).join(', ') || "N/A"}
                </li>
              </ul>
            </div>
          </div>

          {/* Prescription History Table */}
          <h4>Prescription Records</h4>
          {prescriptions.length === 0 ? (
            <p>No prescriptions found.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Date</th>
                    <th>Diagnosis</th>
                    <th>Medicine</th>
                    <th>Dosage</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {prescriptions.map((record, index) =>
                    record.prescriptions.map((p, i) => (
                      <tr key={`${index}-${i}`}>
                        <td>{new Date(record.recordDate).toLocaleDateString()}</td>
                        <td>{record.diagnosis}</td>
                        <td>{p.medicineName}</td>
                        <td>{p.dosage.map(d => `${d.quantity} - ${d.timing} (${d.relativeToMeal})`).join(', ')}</td>
                        <td>{p.durationInDays} days</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PatientIdList;